import React from 'react';
import { motion } from 'framer-motion';

const partners = [
  {
    name: 'Frankfurt School of Finance & Management',
    logo: '/images/Frankfurt-School-logo.jpg',
    website: 'https://www.frankfurt-school.de/en/home/'
  },
  {
    name: 'Makerere University Business School',
    logo: '/images/MUBS-logo.jpeg',
    website: 'https://www.mubs.ac.ug/'
  },
  {
    name: 'Africa Research and Impact Network',
    logo: '/images/Arin-logo.jpg',
    website: 'https://www.arin-africa.org/'
  }
];

export default function ProgramPartners() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Program Partners</h2>
          <p className="mt-4 text-xl text-gray-600">
            A collaborative initiative by leading institutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {partners.map((partner, index) => (
            <motion.a
              key={partner.name}
              href={partner.website}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-lg shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-16 object-contain"
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}